import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=7d3e4811&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LocaleSwitcher.vue?vue&type=style&index=0&id=7d3e4811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3e4811",
  null
  
)

export default component.exports